import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, UrlSerializer } from '@angular/router';
import { adminJwtInterceptor, adminUnauthenticatedErrorInterceptor, provideAdminAuth } from '@cnt-admin/data-access';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { appRoutes } from './app-routes';
import { LowerCaseUrlSerializer } from './lowercase-serializer';

/**
 * No NgRx: every screen lives in @cnt-admin/* on top of @cnt-workspace/data-access,
 * with state in component-scoped BehaviorSubject services.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideIonicAngular(),
    // Admin links and bookmarks are case-insensitive; query keys must be lowercase (see libs/admin/README.md).
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
    provideAnimations(),
    // Session + token handling come from cnt-landing's AuthService (Cognito) via @cnt-admin/data-access.
    provideHttpClient(withInterceptors([adminJwtInterceptor, adminUnauthenticatedErrorInterceptor])),
    provideAdminAuth(),
    provideRouter(appRoutes),
  ],
};
